// material-ui
import { styled } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export const StyledDateTimePicker = styled(DateTimePicker)`
  & .MuiInputAdornment-positionEnd {
    margin-right: 10px;
  }
`;
